module.exports = __webpack_public_path__ + "static/team6-3f2fbd3b31c0001d926789d48709fbd0.jpg";